import { FC } from "react";
import { COLORS } from "shared/consts";

type NotificationCalendarIconProps = {
  fill?: string;
}
export const NotificationCalendarIcon: FC<NotificationCalendarIconProps> = ({
  fill = COLORS.NEUTRAL.DEFAULT
}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.5 4.5V6.5H17V4.5H18C18.8284 4.5 19.5 5.17157 19.5 6V8.01562L4.5 8.01562V6C4.5 5.17157 5.17157 4.5 6 4.5H7V6.5H8.5V4.5L15.5 4.5ZM4.5 9.51562L4.5 18C4.5 18.8284 5.17157 19.5 6 19.5H18C18.8284 19.5 19.5 18.8284 19.5 18V9.51562L4.5 9.51562ZM6 3H7V1H8.5V3L15.5 3V1H17V3H18C19.6569 3 21 4.34315 21 6V18C21 19.6569 19.6569 21 18 21H6C4.34315 21 3 19.6569 3 18V6C3 4.34315 4.34315 3 6 3Z" fill={fill}/>
    </svg>
  )
}